module.exports = __webpack_public_path__ + "df9f57c08e15dd7079c2458533e40c4e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/Rist/content/images/news/Winter-menu-2017_2.jpg
// module id = 869
// module chunks = 0